import React from 'react';
import styled from 'styled-components';
import { StyledFilterLabel } from '../Text/StyledText';

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;

const StyledCheckbox = styled.input<{ hasError: boolean }>`
    appearance: none;
    border: 1px solid ${({ hasError, theme }) => (!hasError ? theme.colors.charcoal40 : theme.colors.red100)};
    border-radius: 0;
    height: 18px;
    min-width: 18px;
    width: 18px;
    background: white;
    position: relative;
    &:checked {
        appearance: none;
        background: ${({ theme }) => theme.colors.charcoal100};
    }

    &:disabled {
        border-color: ${({ theme }) => theme.colors.charcoal20};
    }
`;

interface Props {
    id?: string;
    text: string;
    value: string;
    isChecked: boolean;
    hasError?: boolean;
    disabled?: boolean;
    onChange: (isChecked: boolean, value: string) => void;
    className?: string;
}

const CheckBox: React.FC<Props> = ({
    className,
    id: propId,
    text,
    value,
    isChecked,
    onChange,
    disabled = false,
    hasError = false,
}) => {
    const id = `checkbox-${propId || text}`;
    return (
        <Wrapper className={className}>
            <StyledCheckbox
                data-testid={id}
                id={id}
                checked={isChecked}
                type="checkbox"
                value={value}
                onChange={() => onChange(!isChecked, value)}
                disabled={disabled}
                hasError={hasError}
                aria-invalid={hasError}
            />
            <StyledFilterLabel htmlFor={id} textType="button">
                {text}
            </StyledFilterLabel>
        </Wrapper>
    );
};

export default CheckBox;
